module.exports = __webpack_public_path__ + "img/натютморт со старинными книгами 110х90.d9c1291e.jpg";